import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { JitsuProvider } from "@jitsu/jitsu-react";

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <JitsuProvider options={{ host: "https://track.nativamed.com.br", writeKey: "qWHxrCMMUuDAVFerdJJKnTYfV1pFn2Jo:kZieISGitl4Qm1uxTKKuT3ZoBEOHys5Q"}} >
      <App />
    </JitsuProvider>
  </StrictMode>,
)
